export default __webpack_public_path__ + "static/media/2238.48701cbb.png";